import MDTypography from "@/components/atoms/MDTypography";
import { IMedia } from "@/interfaces/media.interface";

interface TextProps {
  media: IMedia;
}

const ContactsMedia: React.FC<TextProps> = () => {
  return <MDTypography variant="body2">Foi enviado um contato</MDTypography>;
};

export default ContactsMedia;
